import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['experience'] as const;

export const experiencesQueryKeys = {
  base: baseKey,
  getTickets: [...baseKey, 'getTickets'],
  getTransactions: [...baseKey, 'getTransactions'],
  getExperiences: [...baseKey, 'getExperiences'],
} as const;
